import { store } from './configure-store';

export default store;
